import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Research, Service } from '../../services/models'
import userService from '../../services/userService'
import ResearchListComponent from '../../components/ResearchListComponent/ResearchListComponent'
import { Button, Col, Result, Row, Typography } from 'antd'
import { BellFilled, BellOutlined } from '@ant-design/icons'
import { useAppSelector } from '../../app/hooks'
import { permItems, subscribe, unsubscribe } from '../../features/perm/permSlice'
import { useDispatch } from 'react-redux'

type Props = {}

const ServicePage: React.FC<Props> = () => {
  const dispatch = useDispatch()
  const perms = useAppSelector(permItems)
  const navigate = useNavigate()

  const { serviceId } = useParams()
  const [researches, setResearches] = useState<Research[]>([])
  const [service, setService] = useState<Service>()
  const [forbidden, setForbidden] = useState<boolean>(false)

  useEffect(() => {
    if (serviceId) {
      fetchResearchesByServerId(parseInt(serviceId))
    }
  }, [serviceId])

  const fetchResearchesByServerId = (serverId: number) => {
    setForbidden(false)
    userService.getResearchesByServiceId(serverId).then(data => {
      setService(data.service)
      setResearches(data.items)
    }).catch(data => {
      if (data.response.status === 403) {
        setForbidden(true)
      }
    })
  }

  const renderFeed = () => {
    if (!serviceId) return
    const id = parseInt(serviceId)
    const p = perms.find((i) => i.serviceId === id)
    if (!p) return null
    // Кнопка с текстом, а не одна иконка: без подписи непонятно, что колокольчик
    // вообще переключает и в каком состоянии находится подписка сейчас.
    return <Button onClick={() => {
      if (p.isSubscribed) {
        dispatch(unsubscribe(id))
        userService.unsubscribe(id)
      } else {
        dispatch(subscribe(id))
        userService.subscribe(id)
      }
    }} icon={p.isSubscribed ? <BellFilled/> : <BellOutlined/>}>
      {p.isSubscribed ? 'Отписаться' : 'Подписаться'}
    </Button>
  }

  if (forbidden) {
    return (
        <Result
            status="403"
            title="Закрыто"
            subTitle="Извините, но доступ к этой странице закрыт."
            extra={<Button type="primary" onClick={() => navigate('/')}>Вернуться на главную</Button>}
        />
    )
  }

  if (!service) {
    return <></>
  }

  return (
      <div>
        <Row justify={'space-between'}>
          <Col><Typography.Title level={3}>{service.name}</Typography.Title></Col>
          <Col>{renderFeed()}</Col>
        </Row>
        <ResearchListComponent items={researches}/>
      </div>
  )
}

export default ServicePage
